import React, { useState } from "react";
import MenuTabs from "../components/portofolioTabs";
import MenuItems from "../components/MenuItems";
import items from "../data/DataPortofolio";
import { Box, Stack, Typography } from "@mui/material";
import useStyles from "../components/MainTitle";
import { motion } from "framer-motion";
const allCategories = ["all", ...new Set(items.map((item) => item.category))];

function Portofolio() {
  const [menuItems, setMenuItems] = useState(items);
  const classes = useStyles();

  const filterItems = (category) => {
    if (category === "all") {
      setMenuItems(items);
      return;
    }
    const newItems = items.filter((item) => item.category === category);
    setMenuItems(newItems);
  };

  const [categories, setCategories] = useState(allCategories);
  return (
    <div>
      <Stack direction="row">
        <Box className={classes.BigTitle}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0, transition: { duration: 1 } }}
          >
            Portfolio
          </motion.div>
          <Box className={classes.SmallTitle}>
            <motion.div
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0, transition: { duration: 1 } }}
            >
              WORK
              <Box className={classes.afterClass} />
            </motion.div>
          </Box>
        </Box>
      </Stack>
      <Box>
        <motion.div
          initial={{ opacity: 0, scale: 0 }}
          animate={{
            opacity: 1,
            scale: 1,
            transition: { duration: 0.7, delay: 0.6 },
          }}
        >
          <Typography
            sx={{
              margin: "10px auto",
              textAlign: { xs: "justify", md: "center" },
            }}
          >
            Welcome to my portfolio, a showcase of my creative works and a
            testament to my passion for design. From website development to
            branding, SEO marketing to ecommerce design, this collection of
            projects reflects my diverse skillset and dedication to crafting
            beautiful and functional digital experiences.
          </Typography>
        </motion.div>
      </Box>
      <MenuTabs
        filterItems={filterItems}
        categories={categories}
        setCategories={setCategories}
      />
      <MenuItems items={menuItems} />
    </div>
  );
}

export default Portofolio;
